import Footer from "../../Components/Footer/Footer";

const videos = [
  {
    id: "x2SHwQZDlaw",
    title: "",
  },
];

const VideoCard = ({ id, title }) => (
  <div className="rounded-2xl overflow-hidden bg-gray-900/60 border border-purple-900/30 hover:border-gold/40 transition-all duration-500 group">
    <div className="relative aspect-video">
      <iframe
        src={`https://www.youtube.com/embed/${id}`}
        className="absolute inset-0 w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title || "Inspiration video"}
      />
    </div>
    {title && (
      <div className="p-4">
        <h3 className="text-white font-semibold text-lg group-hover:text-gold transition-colors duration-300">
          {title}
        </h3>
      </div>
    )}
  </div>
);

const Inspirations = () => {
  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      {/* Header */}
      <section className="pt-28 pb-12 px-6 bg-gradient-to-b from-purple-950/30 to-[#0a0a0f]">
        <div className="max-w-5xl mx-auto text-center">
          <p className="text-gold text-xs uppercase tracking-[0.2em] font-semibold mb-3">
            Mood Board
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 font-heading">
            Inspirations
          </h1>
          <div className="w-20 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mb-6" />
          <p className="text-gray-400 max-w-2xl mx-auto leading-relaxed">
            The energy, movement, and artistry that shape our performances.
          </p>
        </div>
      </section>

      {/* Video Grid */}
      <section className="px-6 pb-20">
        <div className="max-w-5xl mx-auto">
          <div className={`grid gap-8 ${videos.length === 1 ? "max-w-3xl mx-auto" : "grid-cols-1 md:grid-cols-2"}`}>
            {videos.map((video) => (
              <VideoCard key={video.id} {...video} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Inspirations;
